import { useQuery } from "@tanstack/react-query";
import { controlKeys } from "../queryKeys";
import useAPI from "./useAPI";

const useFullControl = (control) => {
  const { fetchControlMisconfigurations } = useAPI();

  const {
    data: misconfigurations,
    isLoading,
    isSuccess,
  } = useQuery({
    queryKey: controlKeys.controlMisconfigurations(control?.control_id),
    queryFn: () => fetchControlMisconfigurations(control?.control_id),
    enabled: !!control?.control_id,
    select: (response) => response.data,
  });

  // Create enhanced control object with the fetched misconfigurations data
  const fullControl = !control
    ? null
    : {
        ...control,
        misconfigurations: misconfigurations,
      };

  return {
    fullControl,
    isLoading,
    isSuccess,
  };
};

export default useFullControl;
